import { add, formatMoney, ZERO_MONEY } from '@aeris/money';
import { printedDay } from "./statement.js";
const plain = (amount) => formatMoney(amount, { symbol: false });
/** `"2.5000"` → `2,5%`, sem zeros à direita. */
export const rateLabel = (rate) => {
    const [whole = '0', fraction = ''] = rate.split('.');
    const trimmed = fraction.replace(/0+$/, '');
    return `${String(Number.parseInt(whole, 10))}${trimmed === '' ? '' : `,${trimmed}`}%`;
};
const KIND_LABEL = {
    sale: 'venda',
    return: 'vale',
    sale_reversal: 'cancelada',
};
export const commissionStatementFor = (input) => {
    const blocks = [
        { kind: 'text', text: input.company.name, align: 'center', bold: true },
        { kind: 'rule' },
        {
            kind: 'text',
            text: 'EXTRATO DE COMISSÃO',
            align: 'center',
            bold: true,
        },
        { kind: 'rule' },
        { kind: 'pair', label: 'Vendedor', value: input.seller },
        { kind: 'pair', label: 'Mês', value: input.period },
        {
            kind: 'pair',
            label: 'Situação',
            value: input.status === 'closed' && input.closedAt !== null
                ? `fechado em ${printedDay(input.closedAt)}`
                : 'prévia, ainda não fechado',
        },
        { kind: 'rule' },
    ];
    if (input.lines.length === 0) {
        blocks.push({
            kind: 'text',
            text: 'Nenhuma venda no mês.',
            align: 'center',
        });
    }
    for (const line of input.lines) {
        blocks.push({
            kind: 'text',
            text: `${printedDay(line.occurredAt)} ${line.description}${line.fromEarlierPeriod ? ' (mês anterior)' : ''}`,
        });
        for (const item of line.items ?? []) {
            blocks.push({
                kind: 'text',
                text: `  ${item.quantity} × ${item.description}`,
            });
        }
        blocks.push({
            kind: 'pair',
            label: `  ${KIND_LABEL[line.kind]} · ${rateLabel(line.rate)}`,
            value: plain(line.base),
        });
    }
    blocks.push({ kind: 'rule' }, { kind: 'pair', label: 'Vendas', value: plain(input.salesAmount) }, { kind: 'pair', label: 'Vales (−)', value: plain(input.returnsAmount) }, {
        kind: 'pair',
        label: 'Canceladas (−)',
        value: plain(input.reversalsAmount),
    }, { kind: 'pair', label: 'Base', value: plain(input.baseAmount) }, { kind: 'text', text: 'COMISSÃO', big: true, bold: true }, {
        kind: 'text',
        text: formatMoney(input.commissionAmount),
        align: 'right',
        big: true,
        bold: true,
    }, { kind: 'rule' }, { kind: 'feed', lines: 2 }, { kind: 'text', text: '______________________________', align: 'center' }, { kind: 'text', text: input.seller, align: 'center' }, { kind: 'feed', lines: 2 }, { kind: 'cut' });
    return { kind: 'report', title: 'Extrato de comissão', blocks };
};
export const commissionMonthReportFor = (input) => {
    const closed = input.sellers.filter((seller) => seller.status === 'closed');
    const situation = input.sellers.length === 0 || closed.length === 0
        ? 'prévia, ainda não fechado'
        : closed.length === input.sellers.length
            ? 'fechado'
            : 'parcial: parte dos vendedores fechada';
    const blocks = [
        { kind: 'text', text: input.company.name, align: 'center', bold: true },
        { kind: 'rule' },
        { kind: 'text', text: 'COMISSÕES DO MÊS', align: 'center', bold: true },
        { kind: 'rule' },
        { kind: 'pair', label: 'Mês', value: input.period },
        { kind: 'pair', label: 'Situação', value: situation },
        { kind: 'rule' },
    ];
    if (input.sellers.length === 0) {
        blocks.push({
            kind: 'text',
            text: 'Nenhum vendedor com venda no mês.',
            align: 'center',
        });
    }
    let base = ZERO_MONEY;
    let commission = ZERO_MONEY;
    for (const seller of input.sellers) {
        blocks.push({
            kind: 'pair',
            label: seller.seller,
            value: plain(seller.commissionAmount),
        }, {
            kind: 'text',
            text: `  base ${plain(seller.baseAmount)} · ${seller.rates} · ${seller.status === 'closed' ? 'fechado' : 'prévia'}`,
        });
        base = add(base, seller.baseAmount);
        commission = add(commission, seller.commissionAmount);
    }
    if (input.sellers.length > 0) {
        blocks.push({ kind: 'rule' }, { kind: 'pair', label: 'Base', value: plain(base) }, { kind: 'pair', label: 'Comissão', value: plain(commission), bold: true });
    }
    blocks.push({ kind: 'feed', lines: 2 }, { kind: 'cut' });
    for (const seller of input.sellers) {
        blocks.push(...commissionStatementFor(seller).blocks);
    }
    return { kind: 'report', title: 'Comissões do mês', blocks };
};
//# sourceMappingURL=commission-statement.js.map